angular.module('charts')
  .directive("timeframeDropdown", function() {
    return {
      restrict: "E",
      transclude: true,
      scope: {
        years: '=',
        timeframes: '=',
        timeframeOnly: '=',
        hideTimeframeLabel: '=',
        allowCurrentDate: '='
      },
      templateUrl: '/resources/charts/partials/timeframe-dropdown.html',
      controller: [
        '$filter',
        '$scope',
        '$element',
        '$timeout',
        'timeframe',
        '$state',
        'moment',
        'configuration',
        'calendarUnitFilter',
        '$rootScope',
        function(
           $filter, $scope, $element, $timeout, $timeframe, $state, $moment,
           $configuration, $calendarUnitFilter, $rootScope) {

        $scope.timeframes.selected.name = 'Select Timeframe';
        $scope.years.selected.name = 'Select A Year';
        $scope.showCustom = false;

        var initializeSummerDateRange = function () {
            var currentDate = $moment();
            var overrideFrom;
            var overrideTo;
            var summerMinMax;

            if ($timeframe.isCustomSummerRange()) {
                overrideFrom = $moment($timeframe.getFromDate(), 'YYYYMMDD');
                overrideTo = $moment($timeframe.getToDate(), 'YYYYMMDD');

                summerMinMax = $timeframe.calculateCustomSummerMinMax(overrideFrom, currentDate, $scope.allowCurrentDate);

                // This checks to make sure the custom date range in the state is valid.  If not,
                // then pretend like there are no pre-selected custom dates.
                if (summerMinMax.from.min.isAfter(overrideFrom) || summerMinMax.from.max.isBefore(overrideFrom) ||
                    summerMinMax.to.min.isAfter(overrideTo) || summerMinMax.to.max.isBefore(overrideTo) ||
                    overrideTo.isBefore(overrideFrom)) {
                  overrideFrom = null;
                  overrideTo = null;
                }
            } else {
                summerMinMax = $timeframe.calculateCustomSummerMinMax(null, currentDate, $scope.allowCurrentDate);
            }

            summerMinMax.from.date = (overrideFrom || summerMinMax.from.defaultValue).toDate();
            summerMinMax.to.date = (overrideTo || summerMinMax.to.defaultValue).toDate();

            $scope.summerDateRange = summerMinMax;
        };

        var updateTimeframeVisibility = function() {
            if(!$scope.years || !$scope.years.selected) {
                return;
            }
            $scope.showTimeframes = !!($moment().year() === $scope.years.selected.id || $scope.timeframeOnly);
        };

        var findSelectedOrDefaultItem = function(list, selectedId) {
            // TODO: why does this get called three times with changing
            // values for selectedId when you switch tabs

            var defaultItem = null;
            var selectedItem = null;

            if ($timeframe.isCustomRange(selectedId)) {
                var timeframeId = $state.params.timeframeId;
                selectedId = timeframeId || "custom";
                $timeframe.setDefaultTimeframeMode('false');
            }

            // Iterate through and find the selected year / timeframe
            // from the $state.params.timeframe / selectedId param
            // Also send back the default item to show if we cannot
            // find the selected one.
            list.forEach(function(item) {
                if(item.id === selectedId) { selectedItem = item; }
                if(item.active) { defaultItem = item; }
            });

            var isDefaultTfMode = $timeframe.isDefaultTimeframeMode();

            if (isDefaultTfMode === null && selectedItem === null) {
                $timeframe.setDefaultTimeframeMode('true');
            } else if (isDefaultTfMode === 'true' && defaultItem !== null) {
                selectedItem = defaultItem;
            }

            return { defaultItem: defaultItem, selectedItem: selectedItem };
        };

        var transformYears = function(years) {
          // Spruce up years list to something more usable
          var updatedYears = _.map(years, function(year) {
            var id = year + 'y';
            var isCurrentSchoolYear = parseInt(year) === parseInt($timeframe.calculateCurrentReportingYear());
            var localizationKey = isCurrentSchoolYear ? 'currentSchoolYear' : 'yearSchoolYear';
            var name = $filter('translate')('shared.timeframes.' + localizationKey, { year: year });

            // Include the 'by: month' key/value to years' list
            return _.extend({}, year, {by: 'month', id: id, name: name});
          });

          return updatedYears.reverse();
        };

        var mergeTimeframes = function() {
          // @NOTE: Because the timeframe list is on a $watch and will
          // essentially run twice (once in the controller initialization and once here),
          // We strip out all year objects and custom objects.
          // TODO: this rebuilding can probably be avoided by pulling this timeframe list building logic
          // out into a service that can be called from the controllers
          var timeframeList = $scope.timeframes.list.filter(function(obj) {
              // Strip out year and custom objects
              if(obj.id.indexOf('y') === -1 && obj.id.indexOf('custom') === -1 && obj.id.indexOf('custom-summer') === -1) {
                  return true;
              }
          });

          // incorporate custom date range object
          var showCustomDateRange = $state.params.pane !== "performance";
          if (showCustomDateRange) {
              timeframeList.push({id:"custom", name: $filter('translate')('shared.timeframes.custom'), by: "week"});
          }

          // add the current year and previous years
          timeframeList = timeframeList.concat(transformYears($scope.years.list));

          // insert summer school after the current school year or custom date range in the list
          if (showCustomDateRange) {
              var summerSchoolEntry = {
                  id: 'custom-summer',
                  name: $filter('translate')('shared.timeframes.latestSummerSchool'),
                  by: 'week'
              };

              var currentYearIndex = _.findIndex(timeframeList, function (timeframe) {
                  return timeframe.name === $filter('translate')('shared.timeframes.currentSchoolYear');
               });

              if (currentYearIndex >= 0) {
                  timeframeList.splice(currentYearIndex + 1, 0, summerSchoolEntry);
              } else {
                  // if no current year then try to put after custom date range options
                  var timeframeCustomIndex = _.findIndex(timeframeList, function (timeframe) {
                      return timeframe.id === $timeframe.TIMEFRAME_CUSTOM;
                   });

                  if (timeframeCustomIndex >= 0) {
                      timeframeList.splice(timeframeCustomIndex + 1, 0, summerSchoolEntry);
                  }
              }
          }

          // append year objects
          $scope.timeframes.list = timeframeList;
        };

        // Check for a timeframe living in the dropdown
        // that may not match what is in the @param $state.timeframe
        // dispatch a timeframeInitialized event if the timeframe is correct
        var checkTimeFrames = function() {
          var contains = $timeframe.containsTimeframe($scope.timeframes.list);
          var currentDate = $moment();
          var isCustom = !contains && $timeframe.isValidCustomRange($scope.years.list, currentDate, $scope.allowCurrentDate);
          if (!contains && !isCustom) {
            // reset the report dates of the root scope to hide the old label
            $rootScope.reportDates = null;

            var id = isCustom ? "30d" : $scope.timeframes.selected.id;
            var by = isCustom ? "week" : $scope.timeframes.selected.by;

            // timeout fixes IN-2689  Spinner at first open at Grades and Classes
            $timeout(function () {
                var promise = $timeframe.updateStateParams(id, by);
                promise.then(function() {
                    $scope.$emit('timeframeSelected', $scope.timeframes.selected);
                });
            });
          } else {
            if (!$state.params.timeframe) {
              $timeout(function () {
                $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by, $scope.timeframes.selected.id)
                    .then(function () {
                    $scope.$emit('timeframeInitialized', $scope.timeframes.selected);
                });
              });
            } else {
                //this function is called everytime the year list is populated. without the default time frame
                //computation and firing of event the backend api call fires before the dropdown finishes rendering
                if ($timeframe.isDefaultTimeframeMode() === 'true') {
                    var timeframe = findSelectedOrDefaultItem($scope.timeframes.list, $state.params.timeframe);
                    // timeout fixes IN-2689  Spinner at first open at Grades and Classes
                    $timeout(function () {
                        $timeframe.updateStateParams(timeframe.defaultItem.id, timeframe.defaultItem.by, timeframe.defaultItem.id)
                          .then(function () {
                              $scope.$emit('timeframeInitialized', timeframe.defaultItem);
                          });
                    });
                } else {
                    $scope.$emit('timeframeInitialized', $scope.timeframes.selected);
                }
            }
          }
        };

        $scope.$watch('timeframes.list', function(newValue) {
          // TODO: why check if newValue.length is less than zero?  how is that possible?
          if( !newValue || newValue.length <= 0) { return; }

          var timeframe = findSelectedOrDefaultItem(newValue, $state.params.timeframe);
          $scope.timeframes.selected = timeframe.selectedItem || timeframe.defaultItem;
          updateTimeframeVisibility();

          if ($scope.showTimeframes && $scope.timeframes.selected) {
            showCustomRange($scope.timeframes.selected.id);
          }

        });

        var showCustomRange = function (selectedId) {
          if (selectedId === 'custom') {
            $scope.showCustom = true;
            $scope.showCustomSummer = false;
          } else if (selectedId === 'custom-summer') {
            $scope.showCustom = false;
            $scope.showCustomSummer = true;
          } else {
            $scope.showCustom = false;
            $scope.showCustomSummer = false;
          }
        };

        $scope.$watch('years.list', function(newValue) {
          // bug 51179
          // when we get an empty reporting_years array back from g2 - show the current school year as an option
          // NOTE that we won't include it if there are years specified and it is not one of them
          // reason for that is to allow accurate representation for the historic rosters
          if (newValue && newValue.length === 0) {
            newValue.push($timeframe.calculateCurrentReportingYear());
          }

          if( !newValue || newValue.length <= 0) { return; }

          if($scope.timeframeOnly) {
            mergeTimeframes();
            checkTimeFrames();
          }

          var year = findSelectedOrDefaultItem(newValue, $timeframe.parseNumber());
          $scope.years.selected = year.selectedItem || year.defaultItem;
          updateTimeframeVisibility();
        });

        $scope.selectYear = function(selected) {
          updateTimeframeVisibility();

          var promise = $timeframe.updateStateParams(selected.id + 'y', selected.by);
          promise.then(function() {
            $scope.$emit('yearSelected', selected);
          });
        };

        $scope.selectTimeframe = function(selected) {
            showCustomRange(selected.id);

            // Don't update params yet if using custom date range
            if (selected.id !== 'custom' && selected.id !== 'custom-summer') {
                var isDefault = selected.active;

                if (isDefault !== undefined) {
                    if (isDefault) {
                        $timeframe.setDefaultTimeframeMode('true');
                    } else {
                        $timeframe.setDefaultTimeframeMode('false');
                    }
                }

                var promise = $timeframe.updateStateParams(selected.id, selected.by);
                promise.then(function() {
                  $scope.$emit('timeframeSelected', selected);
                });
            }
        };

        $scope.$on('customDateRangeSet', function(e, dateRange) {
          // get fd and td
          var fd = $moment(dateRange.fd);
          var td = $moment(dateRange.td);

          // update $state params (url encode date pattern: timeframe=fd20160108td20160906
          var formatFd = String(fd.format('YYYYMMDD'));
          var formatTd = String(td.format('YYYYMMDD'));
          var timeframe = 'fd'+formatFd+'td'+formatTd;
          var timeframeId = $scope.timeframes.selected.id;

          var interval = td.diff(fd, 'days');

          var promise = $timeframe.updateStateParams(timeframe, $calendarUnitFilter(interval), timeframeId);
          promise.then(function() {
            $scope.$emit('timeframeSelected');
          });
        });

        initializeSummerDateRange();

      }]
    };
  });
